import React from 'react';
import './TermsAndConditions.css'; 

const TermsAndConditions = () => {
  return (
    <div className="terms-conditions-container">
      <h1>Terms and Conditions ("Terms")</h1>
      <section> 
        <p>Last Updated: April 17, 2024. Please read these terms and conditions carefully before using the EECS CoP Mentor Matching Site operated by Oregon State University’s EECS Department.</p> 
      </section>
      <section>
        <h2>Acknowledgment</h2>
        <p>These Terms govern your access to and use of the EECS CoP Mentor Matching Site, and constitute an agreement between you, the user, and Oregon State University. By accessing or using the Service, you agree to be bound by these Terms. If you disagree with any part of the terms, you are not permitted to use the Service.</p>
      </section>
      <section>
        <h2>Privacy Policy</h2>
        <p>Your privacy is important to us. It is Oregon State University's policy to respect your privacy regarding any information we may collect from you across our website. Please refer to our Privacy Policy for more details.</p>
      </section>
      <section>
        <h2>Creating Accounts</h2>
        <p>When you create an account with us, you must provide information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account.</p>
      </section>
      <section>
        <h2>User Responsibilities</h2>
        <p>You are responsible for your account and any activity on it. You must safeguard your password and notify us immediately of any unauthorized use of your account.</p>
      </section>
      <section>
        <h2>Intellectual Property</h2>
        <p>The Service and its original content, features, and functionality are owned by Oregon State University and are protected by copyright and other intellectual property laws.</p>
      </section>
      <section>
        <h2>Changes to Terms</h2>
        <p>We reserve the right to modify these Terms at any time. We will provide notice of any significant changes and continue your use of the Services following such notice will constitute your acceptance of the revised Terms.</p>
      </section>
      <section>
        <h2>Termination</h2>
        <p>We may terminate or suspend your Account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach these Terms and Conditions. Upon termination, your right to use the Service will cease immediately. If you wish to terminate your Account, you may simply discontinue using the Service. </p>
      </section>
      <section>
        <h2>Contact Us</h2>
        <p>If you have any questions about these Terms, please contact us at: eecsadmin@oregonstate.edu. </p>
      </section>
    </div>
  );
}

export default TermsAndConditions;
